import React from "react";
import { Helmet } from "react-helmet";

const Head = ({ ...props }) => {
  return (
    <Helmet>
      <title>
        {props.title ? props.title + " | " : ""} Fuel Pricing Platform
      </title>
    </Helmet>
  );
};
export default Head;
